import type { StateCreator } from 'zustand';

/**
 * Preferences Slice - Préférences utilisateur
 */
export interface PreferencesSlice {
  // View preferences
  defaultView: 'grid' | 'list';
  setDefaultView: (view: 'grid' | 'list') => void;

  // Pagination
  itemsPerPage: number;
  setItemsPerPage: (items: number) => void;

  // Theme (pour future dark mode)
  theme: 'light' | 'dark' | 'auto';
  setTheme: (theme: 'light' | 'dark' | 'auto') => void;

  // Language
  language: 'fr' | 'en';
  setLanguage: (lang: 'fr' | 'en') => void;

  // Reset all preferences
  resetPreferences: () => void;
}

const DEFAULT_PREFERENCES = {
  defaultView: 'grid' as const,
  itemsPerPage: 20,
  theme: 'light' as const,
  language: 'fr' as const,
};

export const createPreferencesSlice: StateCreator<PreferencesSlice> = (set) => ({
  ...DEFAULT_PREFERENCES,

  setDefaultView: (view) => set({ defaultView: view }),

  setItemsPerPage: (items) => set({ itemsPerPage: items }),

  setTheme: (theme) => set({ theme }),

  setLanguage: (lang) => set({ language: lang }),

  resetPreferences: () => set(DEFAULT_PREFERENCES),
});
